import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, signal } from '@angular/core';
import { MessageService } from './alarms/services/webservice/message.service';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true, 
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    
  ]
})


export class AppComponent {
  protected readonly title = signal('stk-rs-app-v2');
}